export const steps = [
  { title: 'Step 1',
    progress: -20,
  },
  {
    title: 'Step 2',
    progress: 0,
  },
  {
    title: 'Step 3',
    progress: 20,
  },
  {
    title: 'Step 4',
    progress: 40,
  },
  {
    title: 'Step 5',
    progress: 60,
  },
  {
    title: 'Step 6',
    progress: 80,
  },
  {
    title: 'Step 7',
    progress: 100,
  },
  {
    title: 'Step 8',
    progress: 120,
  },
  {
    title: 'Step 9',
    progress: 140,
  },
  {
    title: 'Step 10',
    progress: 160,
  },
];

export const stepsServices = [
  { title: 'Step 1',
    progress: 0,
  },
  {
    title: 'Step 2',
    progress: 20,
  },
  {
    title: 'Step 3',
    progress: 30,
  },
  {
    title: 'Step 4',
    progress: 40,
  },
  {
    title: 'Step 5',
    progress: 50,
  },
  {
    title: 'Step 6',
    progress: 60,
  },
  {
    title: 'Step 7',
    progress: 70,
  },
  {
    title: 'Step 8',
    progress: 80,
  },
  {
    title: 'Step 9',
    progress: 100,
  },
];
